import { CALL_API, Schemas } from '../../common/middleware/api';

export const WORKSHOP_WEEK_SESSIONS_REQUEST = 'WORKSHOP_WEEK_SESSIONS_REQUEST';
export const WORKSHOP_WEEK_SESSIONS_SUCCESS = 'WORKSHOP_WEEK_SESSIONS_SUCCESS';
export const WORKSHOP_WEEK_SESSIONS_FAILURE = 'WORKSHOP_WEEK_SESSIONS_FAILURE';

export const CHILD_WORKSHOP_SESSIONS_UNPAGED_REQUEST = 'CHILD_WORKSHOP_SESSIONS_UNPAGED_REQUEST';
export const CHILD_WORKSHOP_SESSIONS_UNPAGED_SUCCESS = 'CHILD_WORKSHOP_SESSIONS_UNPAGED_SUCCESS';
export const CHILD_WORKSHOP_SESSIONS_UNPAGED_FAILURE = 'CHILD_WORKSHOP_SESSIONS_UNPAGED_FAILURE';

export const CHILD_WORKSHOP_SESSION_UPDATE_REQUEST = 'CHILD_WORKSHOP_SESSION_UPDATE_REQUEST';
export const CHILD_WORKSHOP_SESSION_UPDATE_SUCCESS = 'CHILD_WORKSHOP_SESSION_UPDATE_SUCCESS';
export const CHILD_WORKSHOP_SESSION_UPDATE_FAILURE = 'CHILD_WORKSHOP_SESSION_UPDATE_FAILURE';

export const loadWeekSessions = (weekId) => ({
	[CALL_API]: {
		types: [WORKSHOP_WEEK_SESSIONS_REQUEST, WORKSHOP_WEEK_SESSIONS_SUCCESS, WORKSHOP_WEEK_SESSIONS_FAILURE],
		endpoint: `api/workshopWeeks/${weekId}/sessions`,
		schema: Schemas.WEEK_SESSIONS
	}
});

export const loadUnpagedChildSessions = (options) => ({
	[CALL_API]: {
		types: [CHILD_WORKSHOP_SESSIONS_UNPAGED_REQUEST, CHILD_WORKSHOP_SESSIONS_UNPAGED_SUCCESS, CHILD_WORKSHOP_SESSIONS_UNPAGED_FAILURE],
		endpoint: 'api/childWorkshopSessions/unpaged',
		request: options,
		schema: Schemas.CHILD_WORKSHOP_SESSIONS_ARRAY,
		replace: { replace: true }
	}
});

export const updateChildSession = (id, session, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CHILD_WORKSHOP_SESSION_UPDATE_REQUEST, CHILD_WORKSHOP_SESSION_UPDATE_SUCCESS, CHILD_WORKSHOP_SESSION_UPDATE_FAILURE],
		endpoint: `api/childWorkshopSessions/${id}`,
		method: 'PUT',
		request: session,
		schema: Schemas.CHILD_WORKSHOP_SESSION,
		onSuccessEvent
	}
});